
<script setup>
    import { useRouter, useRoute } from 'vue-router'

    import IconBasket from '../components/icons/iconBasket.vue'
    import IconHome from '../components/icons/iconHome.vue'
    import IconNote from '../components/icons/iconNote.vue'
    import IconPrice from '../components/icons/iconPrice.vue'
    import IconUserCircle from '../components/icons/iconUserCircle.vue'

    const router = useRouter()
    const route = useRoute()

    const goHomePage = () => {
        router.push({name:'dashboard'})
    }

    const goPromoPage = () => {
        router.push({name:'promo'})
    }

    const goShoppingPage = () => {
        router.push({name:'shopping'})
    }

    const goActivityPage = () => {
        router.push({name:'activity'})
    }

    const goAccountPage = () => {
        router.push({name:'account'})
    }

</script>
<template>
    <div class="bottom-wrapper">
        <div id="bottom-nav">
            <div class="nav-item" :class=" route.name == 'dashboard' ?'active' :'' ">
                <button class="btn" @click="goHomePage">
                    <IconHome size="20"/>
                </button>
                <span>Beranda</span>
            </div>
            <div class="nav-item" :class=" route.name == 'promo' ?'active' :'' ">
                <button class="btn" @click="goPromoPage">
                    <IconPrice size="20"/>
                </button>
                <span>Promo</span>
            </div>
            <div class="nav-item nav-item-center">
                <div class="nav-center" role="button" @click="goShoppingPage">
                    <div class="center-circle">
                        <IconBasket size="30" />
                    </div>
                    <span>Belanja</span>
                </div>
            </div>
            <div class="nav-item" :class=" route.name == 'activity' ?'active' :'' ">
                <button class="btn" @click="goActivityPage">
                    <IconNote size="20"/>
                </button>
                <span>Aktifitas</span>
            </div>
            <div class="nav-item" :class=" route.name == 'account' ?'active' :'' ">
                <button class="btn" @click="goAccountPage">
                    <IconUserCircle size="20"/>
                </button>
                <span>Akun</span>
            </div>
        </div>
    </div>
</template>